export default "__VITE_ASSET__CO2cPuw4__"